import { render, staticRenderFns } from "./MyMenuContainer.vue?vue&type=template&id=266d1352"
import script from "./MyMenuContainer.vue?vue&type=script&lang=js"
export * from "./MyMenuContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports